export default "__VITE_ASSET__DwQ1woYA__"